import { JobStatusEnum } from '~/models';
import { Colors } from '~/themes/colors';

export enum OnsiteInterviewStatus {
  ActionNeeded = 'action_needed',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Open = 'open',
  Scheduled = 'scheduled',
}

const colors: Record<OnsiteInterviewStatus, string> = {
  [OnsiteInterviewStatus.ActionNeeded]: Colors.error_450,
  [OnsiteInterviewStatus.Cancelled]: Colors.warning_500,
  [OnsiteInterviewStatus.Completed]: Colors.neutral_400,
  [OnsiteInterviewStatus.Open]: Colors.success_500,
  [OnsiteInterviewStatus.Scheduled]: Colors.secondary_500,
};

const translationsHumanReadable: Record<OnsiteInterviewStatus, string> = {
  [OnsiteInterviewStatus.ActionNeeded]: 'Action Needed',
  [OnsiteInterviewStatus.Cancelled]: 'Cancelled & Expired',
  [OnsiteInterviewStatus.Completed]: 'Completed',
  [OnsiteInterviewStatus.Open]: 'Open',
  [OnsiteInterviewStatus.Scheduled]: 'Scheduled',
};

const fromJobStatus = (it: JobStatusEnum): OnsiteInterviewStatus => {
  if ([JobStatusEnum.Counter, JobStatusEnum.Pending].includes(it)) {
    return OnsiteInterviewStatus.ActionNeeded;
  }

  if ([JobStatusEnum.Cancelled, JobStatusEnum.Expired].includes(it)) {
    return OnsiteInterviewStatus.Cancelled;
  }

  if ([JobStatusEnum.Complete].includes(it)) {
    return OnsiteInterviewStatus.Completed;
  }

  if ([JobStatusEnum.Open].includes(it)) {
    return OnsiteInterviewStatus.Open;
  }

  return OnsiteInterviewStatus.Scheduled;
};

const toJobStatus = (it: OnsiteInterviewStatus): JobStatusEnum[] => {
  switch (it) {
    case OnsiteInterviewStatus.ActionNeeded:
      return [JobStatusEnum.Counter, JobStatusEnum.Pending];
    case OnsiteInterviewStatus.Cancelled:
      return [JobStatusEnum.Cancelled, JobStatusEnum.Expired];
    case OnsiteInterviewStatus.Completed:
      return [JobStatusEnum.Complete];
    case OnsiteInterviewStatus.Open:
      return [JobStatusEnum.Open];
    case OnsiteInterviewStatus.Scheduled:
      return [JobStatusEnum.Filled];
  }
};

export const OnsiteInterviewStatusMapper = {
  fromJobStatus,
  getColor: (it: OnsiteInterviewStatus) => colors[it],
  toHumanReadable: (it: OnsiteInterviewStatus) => translationsHumanReadable[it],
  toJobStatus,
};
